var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('stripe-element',{ref:"stripe-element",staticClass:"stripe-card-number",attrs:{"stripe-elements":_vm.stripeElements,"options":{
    showIcon: true
  },"disabled":_vm.disabled,"label":_vm.$t('app.labels.credit_card.number'),"type":"cardNumber","target":"card-number","has-icon":""}},[_c('div',{attrs:{"id":"card-number"}})])}
var staticRenderFns = []

export { render, staticRenderFns }